
(() => {
  const initialized = new WeakSet();

  function initGallery(gallery) {
    if (initialized.has(gallery)) return;
    initialized.add(gallery);

    const scope =
      gallery.closest(".shopify-section") ||
      gallery.closest("section") ||
      document;

    const getMedia = () =>
      [...gallery.querySelectorAll(
        ".product-gallery__media[data-media-id]"
      )].filter(el => !el.hidden && el.getClientRects().length);

    let lastMediaId = null;
    let lockedUntil = 0;
    let timer;

    function syncVariant() {
      if (Date.now() < lockedUntil) return;

      const media = getMedia();
      if (!media.length) return;

  const galleryRect = carousel.getBoundingClientRect();
const center = galleryRect.left + galleryRect.width / 2;

      const active = media.reduce((best, item) => {
        const rect = item.getBoundingClientRect();
        const distance = Math.abs(
          rect.left + rect.width / 2 - center
        );

        return distance < best.distance
          ? { element: item, distance }
          : best;
      }, { element: null, distance: Infinity }).element;

      if (!active) return;

      const mediaId = active.dataset.mediaId;
      if (!mediaId || mediaId === lastMediaId) return;

      const inputs = [
        ...scope.querySelectorAll(
          'input[type="radio"][data-variant-media]'
        )
      ];

      const matching = inputs.find(input => {
        try {
          const data = JSON.parse(input.dataset.variantMedia);
          return String(data.id) === String(mediaId);
        } catch {
          return false;
        }
      });

      if (!matching) return;

      lastMediaId = mediaId;

      if (!matching.checked && !matching.disabled) {
        matching.click();
        lockedUntil = Date.now() + 700;
      }
    }

    function scheduleSync() {
      clearTimeout(timer);
      timer = setTimeout(syncVariant, 140);
    }

const carousel = gallery.querySelector( ".product-gallery__carousel");

if (!carousel) return;

carousel.addEventListener("scroll", scheduleSync, {
  passive: true
});

carousel.addEventListener("scrollend", scheduleSync);

carousel.addEventListener("touchend", () => {
  setTimeout(scheduleSync, 250);
}, { passive: true });

    scope.addEventListener("change", event => {
      if (event.target.matches(
        'input[type="radio"][data-variant-media]'
      )) {
        lockedUntil = Date.now() + 900;
        lastMediaId = null;
      }
    });
  }

  function init() {
    document.querySelectorAll(
      "product-gallery"
    ).forEach(initGallery);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener(
    "shopify:section:load",
    init
  );
})();
